import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/NewProductEntry.css";

const NewProductEntry = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    category_id: "",
    product_name: "",
    prodcut_mrp: "",
    discount_per: "",
    prodcut_stock: "",
    prodcut_expiry_date: "",
    product_description: "",
    photo: null,
  });

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [catLoading, setCatLoading] = useState(true);

  /* =============================
   * FETCH CATEGORIES
   * ============================= */
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = (localStorage.getItem("session_token") || "").trim();
        const response = await fetch(
          `https://newerp.awasthivitality.com/api/category/list${
            token ? `?token=${encodeURIComponent(token)}` : ""
          }`,
          {
            headers: token
              ? {
                  Authorization: `Bearer ${token}`,
                  "X-Session-Token": token,
                }
              : {},
          }
        );

        const data = await response.json();

        if (Array.isArray(data)) {
          setCategories(data);
        } else if (Array.isArray(data?.data)) {
          setCategories(data.data);
        } else {
          toast.warn("⚠️ Invalid category data");
        }
      } catch (err) {
        toast.error("❌ Failed to load categories");
      } finally {
        setCatLoading(false);
      }
    };

    fetchCategories();
  }, []);

  /* =============================
   * HANDLE INPUT CHANGE
   * ============================= */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  /* =============================
   * HANDLE SUBMIT
   * ============================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      !formData.category_id ||
      !formData.product_name.trim() ||
      !formData.prodcut_mrp.trim()
    ) {
      toast.warn("⚠️ Please fill required fields");
      setLoading(false);
      return;
    }

    try {
      const data = new FormData();

      data.append("category_id", formData.category_id);
      data.append("product_name", formData.product_name);
      data.append("prodcut_mrp", formData.prodcut_mrp);

      // OPTIONAL FIELDS
      if (formData.photo) data.append("photo", formData.photo);
      if (formData.discount_per)
        data.append("discount_per", formData.discount_per);
      if (formData.prodcut_stock)
        data.append("prodcut_stock", formData.prodcut_stock);
      if (formData.prodcut_expiry_date)
        data.append("prodcut_expiry_date", formData.prodcut_expiry_date);
      if (formData.product_description)
        data.append("product_description", formData.product_description);

      const token = (localStorage.getItem("session_token") || "").trim();
      const response = await fetch(
        `https://newerp.awasthivitality.com/api/products/add${
          token ? `?token=${encodeURIComponent(token)}` : ""
        }`,
        {
          method: "POST",
          headers: token
            ? {
                Authorization: `Bearer ${token}`,
                "X-Session-Token": token,
              }
            : {},
          body: data,
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        toast.success(" Product added successfully!");

        setFormData({
          category_id: "",
          product_name: "",
          prodcut_mrp: "",
          // discount_per: "",
          // prodcut_stock: "",
          // prodcut_expiry_date: "",
          // product_description: "",
          // photo: null,
        });

        setTimeout(() => navigate("/Product"), 1000);
      } else {
        toast.error(result.msg || "❌ Failed to add product");
      }
    } catch (error) {
      toast.error("❌ Network error, try again");
    } finally {
      setLoading(false);
    }
  };

  /* =============================
   * JSX
   * ============================= */
  return (
    <div className="newproduct-page">
      <div className="newproduct-header">
        <h2>New Product Entry</h2>
      </div>

      <form className="newproduct-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          {/* CATEGORY */}
          <div className="form-group">
            <label>
              Category <span className="required">*</span>
            </label>
            {catLoading ? (
              <p>Loading...</p>
            ) : (
              <select
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option
                    key={cat.category_id || cat.id}
                    value={cat.category_id || cat.id}
                  >
                    {cat.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* PRODUCT NAME */}
          <div className="form-group">
            <label>
              Product Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="product_name"
              value={formData.product_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* MRP */}
          <div className="form-group">
            <label>
              MRP <span className="required">*</span>
            </label>
            <input
              type="number"
              name="prodcut_mrp"
              value={formData.prodcut_mrp}
              onChange={handleChange}
              required
            />
          </div>

          {/* PHOTO */}
          {/* <div className="form-group">
            <label>Photo</label>
            <input type="file" name="photo" accept="image/*" onChange={handleChange} />
          </div> */}

          {/* DISCOUNT */}
          {/* <div className="form-group">
            <label>Discount %</label>
            <input
              type="number"
              name="discount_per"
              value={formData.discount_per}
              onChange={handleChange}
            />
          </div> */}

          {/* STOCK */}
          {/* <div className="form-group">
            <label>Stock</label>
            <input
              type="number"
              name="prodcut_stock"
              value={formData.prodcut_stock}
              onChange={handleChange}
            />
          </div> */}

          {/* EXPIRY */}
          {/* <div className="form-group">
            <label>Expiry Date</label>
            <input
              type="date"
              name="prodcut_expiry_date"
              value={formData.prodcut_expiry_date}
              onChange={handleChange}
            />
          </div> */}
        </div>

        {/* DESCRIPTION */}
        {/* <div className="form-group full-width">
          <label>Description</label>
          <textarea
            name="product_description"
            value={formData.product_description}
            onChange={handleChange}
          />
        </div> */}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Saving..." : "Add Product"}
        </button>
      </form>
    </div>
  );
};

export default NewProductEntry;